import React, { useEffect, useState } from "react";
import { PageSubHeader } from "../../../provider/PageDataProvider";
import { getAppSystem } from "../../services/systemService";
import { Card, CardActionArea, CardContent } from "@material-ui/core";
import { Image } from "react-bootstrap";
import { Typography } from "@material-ui/core";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
export default function Reports({ history }) {
  const { reload } = useGlobalData();
  const [apps, setApps] = useState([]);
  useEffect(() => {
    getAppSystemData();
  }, [reload]);
  return (
    <React.Fragment>
      <PageSubHeader title="Reports" breadcrumbs={[]} actionButtons={[]} />
      <div className="row">
        {apps.map((item, index) => (
          <React.Fragment key={index}>
            {item.appSystem.map((itemMenu, indexMenu) => (
              <React.Fragment key={indexMenu}>
                {itemMenu.appCode === "CRRPT" ||
                itemMenu.appCode === "SARPT" ||
                itemMenu.appCode === "INRPT" ||
                itemMenu.appCode === "PRRPT" ||
                itemMenu.appCode === "FIRPT" ||
                itemMenu.appCode === "USRPT" ? (
                  <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
                    <div>
                      <Card
                        onClick={() => {
                          history.push(itemMenu.appRoute);
                        }}
                      >
                        <CardActionArea>
                          <CardContent>
                            <div className="row">
                              <div className="col-2 py-2">
                                <Typography align="center" className="my-2">
                                  <Image
                                    src={
                                      process.env.PUBLIC_URL +
                                      `/invifo/icons/${itemMenu.appIcon}`
                                    }
                                    style={{
                                      maxWidth: 60,
                                      maxHeight: 60,
                                    }}
                                    className="img-fluid"
                                    alt="Tile Menu"
                                  />
                                </Typography>
                              </div>
                              <div className="col-10 py-2">
                                <Typography
                                  variant="h6"
                                  className="kt-font-bolder"
                                >
                                  {itemMenu.appDesc}
                                </Typography>
                                <Typography variant="subtitle1">
                                  {itemMenu.appCode === "CRRPT"
                                    ? "Explore various reports of CRM module such as Sales Pipeline, Sales Performance, Sales Card, Visit Schedules, Direct Sales, and many more"
                                    : itemMenu.appCode === "SARPT"
                                    ? "Explore various reports of Sales module such as Sales Overview, Customer Analytics, Outlet Sales, Sales Target, and many more"
                                    : itemMenu.appCode === "INRPT"
                                    ? "Explore various reports of Inventory module such as Stock Availability & Value, Stock Movement, Stock Opname, Stock Aging, and many more"
                                    : itemMenu.appCode === "PRRPT"
                                    ? "Explore various reports of Procurement module such as Purchase Overview, Vendor Analytics, Cost Control, and many more"
                                    : itemMenu.appCode === "FIRPT"
                                    ? "Explore various reports of Finance module such as Balance Sheet, Profit Loss, Cash Flow, A/R & A/P Aging, Account Balance, Tax, and many more"
                                    : itemMenu.appCode === "USRPT"
                                    ? "Explore various reports of User module such as User Activity, User Session, User Lock, User Time Spent, User Last Login, and many more"
                                    : null}
                                </Typography>
                              </div>
                            </div>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    </div>
                  </div>
                ) : null}
              </React.Fragment>
            ))}
          </React.Fragment>
        ))}
      </div>
    </React.Fragment>
  );

  async function getAppSystemData() {
    const response = await getAppSystem();
    setApps(response.data);
  }
}
